module.exports = __webpack_public_path__ + "static/img/yl_zct.86ec641.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/yl_zct.png
// module id = wSuo
// module chunks = 0